export default __webpack_public_path__ + "media/images/development-rights-da8277bc814f031f43610a7225573844.png";